import { ToolResult } from '../../types/tool.types';
import { ToolContext } from '../tool-context.type';

export async function setFloorTexture(args: any, context: ToolContext): Promise<ToolResult> {
	const { threeInstance, publish } = context;

	const { texture } = args;
	if (!texture || typeof texture !== 'string') {
		return {
			success: false,
			error: 'texture parameter is required and must be a string (e.g., "floor/grid-tile")'
		};
	}

	// Validate texture key format
	if (!texture.startsWith('floor/')) {
		return {
			success: false,
			error: 'texture must start with "floor/" (e.g., "floor/grid-tile", "floor/concrete-pavers")'
		};
	}

	// Apply floor texture via Three.js instance
	if (threeInstance && threeInstance.changeFloorTexture) {
		threeInstance.changeFloorTexture(texture);
	} else if (threeInstance && threeInstance.changeTexture) {
		// Fallback to legacy changeTexture method (uses 'Floor' with capital F)
		await threeInstance.changeTexture('Floor', texture, null);
	} else {
		return { success: false, error: 'Three.js instance not available or missing floor texture method' };
	}

	publish('floor_texture', 'changed', {
		ref: 'floor',
		old: null,
		new: texture
	});

	return { success: true, data: { texture } };
}

